import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { InputProps } from '@mui/material';
import Grid from '@mui/material/Grid';
import { TextFieldProps } from '@mui/material/TextField';

import { ControlledTextField } from 'components/shared';

interface Props {
  fieldConfigs: FieldConfig[];
  translateKeyPrefix?: string;
}

export type FieldConfig = TextFieldProps & {
  cols?: number;
  name: string;
  disabled?: boolean;
  label: string;
  inputProps?: InputProps;
  type?: string;
};

const FormLayoutGenerator = ({
  fieldConfigs,
  translateKeyPrefix,
  ...textFieldProps
}: Props) => {
  const { t } = useTranslation('common', {
    ...(translateKeyPrefix && { keyPrefix: translateKeyPrefix })
  });
  const { control } = useFormContext();

  return (
    <>
      {fieldConfigs.map((item, index) => (
        <Grid size={{ compact: item.cols ?? 12 }} key={index}>
          <ControlledTextField
            disabled={item.disabled ?? false}
            type={item.type ?? 'number'}
            control={control}
            name={item.name}
            label={t(`details.surcharges.${item.label}`)}
            variant="outlined"
            inputProps={item.inputProps}
            {...textFieldProps}
          />
        </Grid>
      ))}
    </>
  );
};

export default FormLayoutGenerator;
